export default {
    // 设置换行等操作
    replaceBr(html = '') {
        html = html || '';
        return html.replace(/\n\r|\n|\r/g, '<br />');
    }
};
